import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { LAQUESIS_PLATFORM } from 'Constants/device.APP_TARGET';
// import uuidv4 from 'uuid/v4';
// const unqiueIdentifier = uuidv4();

class NinjaLib extends React.Component {
    static propTypes = {
        environment: PropTypes.string,
        hostname: PropTypes.string.isRequired,
        alternateHostName: PropTypes.string,
        config: PropTypes.object,
        libraryLink: PropTypes.string.isRequired
    };

    static defaultProps = {
        config: {}
    };

    constructor(props, context) {
        super(props, context);

        /* global window */
        /* istanbul ignore else */
        if (typeof window !== 'undefined') {
            window.addEventListener('firstTrackingCreated', () => {
                this.setObserver();
                this.loadLibrary('initiated', true);
            });
        }
    }

    removeObserver() {
        /* istanbul ignore else */
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = undefined;
        }
    }

    setObserver() {
        this.timerId = setTimeout(() => {
            /* istanbul ignore else */
            if (typeof window !== 'undefined' && !window.ninja) {
                this.loadLibrary('re-trigger');
            }
            // eslint-disable-next-line no-magic-numbers
        }, 15000);
    }

    loadLibrary(status, shouldRetry) {
        // in UTs stale of shouldRetry is being used, avoid to stale of shouldRetry need to keep this in current object
        this.shouldRetry = shouldRetry;
        // window.newrelic?.addPageAction('NinjaLibLoading', { status, unqiueIdentifier });

        const element = document.createElement('script');

        element.src = this.props.libraryLink;
        element.id = 'ninja-script-tag';
        element.async = true;
        element.onerror = () => {
            this.removeObserver();      // clear any existing timers
            if (this.shouldRetry) {
                this.loadLibrary('retry');
            }
            // else {
            //     window.newrelic?.addPageAction('NinjaLibLoading', { status: 'failed', unqiueIdentifier });
            // }
        };
        element.onload = () => {
            this.removeObserver();      // clear any existing timers
            window.trackingLibraryLoaded = true;
            // window.newrelic?.addPageAction('NinjaLibLoading', { status: 'loaded', unqiueIdentifier });
            // Notify to Tracker Component that library has been loaded
            const trackingLibraryLoadedEvent = document.createEvent('Event');

            trackingLibraryLoadedEvent.initEvent('trackingLibraryLoaded', true, true);

            window.dispatchEvent(trackingLibraryLoadedEvent);
        };

        document.body.appendChild(element);
    }

    config() {
        let config = {
            siteUrl: this.props.alternateHostName || this.props.hostname,
            platform: LAQUESIS_PLATFORM
        };

        const devConfig = {
            environment: this.props.environment,
            setup: {
                mixpanel: {
                    siteCode: '1a7662bbd7c5817248329aee4e486768'
                },
                clevertap: {
                    siteCode: this.props.config.cleverTapId
                },
                ga: {
                    siteCode: this.props.config.gaId
                },
                gtm: {
                    siteCode: this.props.config.gtmId
                }
            },
            plugins: ['LQ'],
            ...this.props.config
        };

        /* istanbul ignore else */
        if (this.props.environment !== 'production') {
            config = { ...config, ...devConfig };
        }

        return JSON.stringify(config);
    }

    getScripts() {
        return [
            {
                type: 'text/javascript',
                innerHTML: `
                    window.dataLayer = window.dataLayer || []; 
                    window.configTracking = ${ this.config() };
                    window.trackingLibraryLoaded = false;
                `
            }
        ];
    }

    render() {
        return (<Helmet
            script={ this.getScripts() }
        />);
    }
}

export default NinjaLib;
